export default interface IEventSetter {
    set(): void;
}
